import {HttpClient}            from '@angular/common/http';
import {inject, Injectable}    from '@angular/core';
import {Auth}                  from '@angular/fire/auth';
import {Timestamp}             from '@angular/fire/firestore';
import {CoachingLogOutputIntf} from '@djsharkk/logr-types';
import {DateTime}              from 'luxon';
import {marked}                from 'marked';
import {BehaviorSubject, map}  from 'rxjs';
import {FirebaseToolsService}  from '../firebase/firebase-tools.service';

@Injectable({
				providedIn: 'root'
			})
export class DataAsstService {
	public svcFirebaseTools = inject(FirebaseToolsService);


	http = inject(HttpClient)

	blankResponse: CoachingLogOutputIntf = {
		content      : '',
		contentParsed: '',
		createdAt    : new Date(),
		id           : ''

	}

	asstThinking = false;
	asstCoachRes: CoachingLogOutputIntf = this.blankResponse;
	asstCoachResTime = new Date();
	userCoachReq = ''

	coachingLogs = new BehaviorSubject<CoachingLogOutputIntf[]>([])


	constructor(private auth: Auth) {

		this.svcFirebaseTools.recFetch<CoachingLogOutputIntf>(
			'asst_records_coaching',
			'createdAt',
			undefined,
			undefined,
			'desc'
		)
			.pipe(
				map(payload => payload.map(record => ({
					...record,
					createdAt    : (record.createdAt as unknown as Timestamp).toDate(),
					contentParsed: marked(record.content, {async: false})
				})))
			)
			.subscribe(payload => {
				this.coachingLogs.next((payload).filter(record => record.content))
				if (payload[0].content === this.asstCoachRes.content) {
					this.asstCoachRes = this.blankResponse;
					this.asstThinking = false
				}
			})
	}


	async getAsstCoaching() {
		// Initialize a variable to store the full response incrementally
		this.asstCoachRes = this.blankResponse; // Declare the variable where chunks get appended
		this.asstThinking = true
		try {
			await this.sendAuthenticatedRequest((chunk: string) => {
				// Update the variable with each chunk
				this.asstCoachRes.content += chunk;
				this.asstCoachRes.contentParsed = marked(this.asstCoachRes.content, {async: false})
				this.asstCoachResTime = new Date();

				// Optional: Log the incremental response
				// console.log('Received chunk:', chunk);
				// console.log('Current state of responseVariable:', this.aiResponse);
			});

			// When the stream ends, do something with the full response
			// console.log('Final response:', this.aiResponse);
		} catch (error) {
			console.error('Error fetching streamed data:', error);
		}
	}

	async sendAuthenticatedRequest(onChunk: (chunk: string) => void): Promise<void> {
		const idToken = await this.auth.currentUser?.getIdToken();

		if (!idToken) {
			throw new Error('User is not authenticated');
		}

		console.log(DateTime.now().startOf('day').toISO())

		// Fetch the API endpoint (streamed response)
		const response = await fetch(
			`${this.svcFirebaseTools.firebaseEndpoint}/aiCoachCheckIn`,
			{
				method : 'POST',
				headers: {
					Authorization : `Bearer ${idToken}`,
					'Content-Type': 'application/json'
				},
				body   : JSON.stringify({
											dateStart: DateTime.now().minus({day: 7}).startOf('day').toISO(), // Send ISO 8601 string
											dateEnd  : DateTime.now().endOf('day').toISO(),
											userReq  : this.userCoachReq
										})
			}
		);

		// Check if the response is OK
		if (!response.ok) {
			throw new Error(`Failed to fetch: ${response.statusText}`);
		}

		// Read stream
		const reader = response.body?.getReader();
		const decoder = new TextDecoder('utf-8');
		let done = false;

		while (!done) {
			const {
					  value,
					  done: streamDone
				  } = await reader?.read()!;
			done = streamDone;

			// Decode each chunk and pass it to the callback
			const chunk = decoder.decode(value, {stream: true});
			if (chunk) {
				onChunk(chunk); // Callback to update the variable incrementally
			}
		}
	}

}
